<template lang="pug">
  .record-download-page.flex.align-start.column.gap-20
    .desc 選擇年份和月份，將下載選定範圍內的收據
    .flex.align-center.gap-12
      el-date-picker(format="yyyy-MM", v-model="month", type="month", placeholder="選擇年份和月份")
      el-button(type="primary", @click="downloadFile") 下載檔案
  </template>

<script>
import {
  startArchiveMonthReceipts,
  getMonthReceiptsStatus,
  downloadMonthReceiptsURL,
} from '@/api/archive';

export default {
  data() {
    return {
      month: undefined,
    };
  },
  methods: {
    downloadFile() {
      if (!this.month) {
        this.$showWarn('請先選擇年份和月份');
        return;
      }
      const start = this.month;
      start.setMonth(start.getMonth(), 1);
      start.setHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setMonth(start.getMonth() + 1, 1);
      end.setHours(0, 0, 0, 0);
      this.$execWithLoading(() => startArchiveMonthReceipts(
        this.$dateToTimestamp(start),
        this.$dateToTimestamp(end),
      ).then((rsp) => {
        // 壓縮檔已存在時不必再輪詢
        if (rsp?.status === 'done') return undefined;
        return this.waitForSuccess(this.$dateToTimestamp(start), this.$dateToTimestamp(end));
      }).then(() => {
        const url = downloadMonthReceiptsURL(
          this.$dateToTimestamp(start),
          this.$dateToTimestamp(end),
        );
        window.open(url, '_blank');
      })
        .catch((e) => {
          // API 錯誤（含斷線）交給 $showAxiosException 轉成中文；其餘為 waitForSuccess 的中文錯誤
          if (e?.isAxiosError) {
            this.$showAxiosException('下載收據失敗', e);
          } else {
            this.$showError(`下載收據失敗: ${e?.message || '未知的錯誤'}`);
          }
        }));
    },
    // 每 3 秒查詢一次打包狀態：pending（尚在佇列）/ running 繼續等待，done 完成，failed 失敗
    waitForSuccess(startAt, endAt) {
      const POLL_MS = 3000;
      const TIMEOUT_MS = 15 * 60 * 1000;
      // 舊版後端在背景任務尚未建立暫存目錄前會回 404，送出後一段時間內視為等待中
      const NOT_FOUND_GRACE_MS = 60 * 1000;
      const startedAt = Date.now();
      return new Promise((resolve, reject) => {
        const interval = setInterval(async () => {
          const elapsed = Date.now() - startedAt;
          try {
            const status = await getMonthReceiptsStatus(startAt, endAt);
            if (status.status === 'done') {
              clearInterval(interval);
              resolve();
              return;
            }
            if (status.status === 'failed') {
              clearInterval(interval);
              reject(new Error('收據打包失敗，請重新下載'));
              return;
            }
          } catch (e) {
            if (!(e?.response?.status === 404 && elapsed < NOT_FOUND_GRACE_MS)) {
              clearInterval(interval);
              reject(e?.response?.status === 404 ? new Error('收據打包失敗，請重新下載') : e);
              return;
            }
          }
          if (elapsed >= TIMEOUT_MS) {
            clearInterval(interval);
            reject(new Error('收據打包逾時，請稍後再試'));
          }
        }, POLL_MS);
      });
    },
  },
};
</script>

  <style lang="scss" scoped>

  </style>
